import { render, staticRenderFns } from "./news_video.vue?vue&type=template&id=f58fcc72"
import script from "./news_video.vue?vue&type=script&lang=js"
export * from "./news_video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports